import App1 from "../ones/App1";
import App2 from "../ones/App2";
import App3 from "../ones/App3";
import App4 from "../ones/App4";
import Projects from "../ones/Projects";

export default function View() {
  return (
    <div style={{ width: "100%", overflowX: "hidden" }}>
      <App1 />
      <App2 />
      <App4 />
      <Projects />
      <App3 />
    </div>
  );
}
